export const STORAGE_KEY = "onboarding";
export const ANDROID_OBESITY_STORE_PAGE_URL =
  "https://play.google.com/store/apps/details?id=se.accumbo.app01&listing=weight-loss";
export const IOS_OBESITY_STORE_PAGE_URL =
  "https://apps.apple.com/us/app/friska/id1370371435?ppid=3ebaf2cc-9c2a-4ccd-a08a-adf69c3f5523";

// Public site. The App Store listing is still named "Blodtrycksdoktorn"; the
// slug above is cosmetic since Apple resolves the numeric id.
export const WEB_BASE_URL = "https://friska.se";
export const PRIVACY_POLICY_URL = `${WEB_BASE_URL}/integritetspolicy/`;
export const TERMS_OF_USE_URL = `${WEB_BASE_URL}/anvandarvillkor/`;
export const PRICING_URL = `${WEB_BASE_URL}/priser/`;
export const FIND_PHARMACY_URL = `${WEB_BASE_URL}/hitta-apotek/`;
export const QUERY_PARAM_WHITELIST = [
  "utm_campaign",
  "utm_content",
  "utm_medium",
  "utm_source",
  "utm_term",
];
